import { Injectable } from '@angular/core';
import { DealerSpecialToolDetailsListViewModel } from '../business-entities/dealer-special-tool-details-view-model';
import { DealerSpecialTool, UpdatedDealerSpecialTool } from '../business-entities/dealer-special-tool-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';


@Injectable({
    providedIn: 'root'
})

export class DealerSpecialToolDataService {
    constructor(private dataProvider: DataService) {
    }

    async getDealerSpecialToolList(vehicalObj:any): Promise<GenericResponse<DealerSpecialToolDetailsListViewModel>> {
        return this.dataProvider.Post<GenericResponse<DealerSpecialToolDetailsListViewModel>>(Urls.GetDealerSpecialToolList,vehicalObj).toPromise();
    }

    // deleteSpecialTool(specialToolId:number){
    //     return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteSpecialTool,specialToolId).toPromise();
    // }

    async getDealerSpecialToolById(specialToolId: number,Language:string): Promise<GenericResponse<DealerSpecialTool>> {
        return this.dataProvider.Get<GenericResponse<DealerSpecialTool>>
        (Urls.GetDealerSpecialTool, specialToolId,Language).toPromise();
    }

    UpdateDealerSpecialTool(model: UpdatedDealerSpecialTool) : Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.EditDealerSpecialTool, model).toPromise();
    }
    
    async GetDealerSpecialToolByBrandId(brandId: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>
        (Urls.GetPartNumberList, brandId).toPromise();
    }
    AssignDealerSpecialTool(model:any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AssignDealerSpecialTool, model).toPromise();
    }
    
}